import React from 'react';

const GradientIcon = ({ Icon, className }) => {
  return (
    <div className={`relative ${className}`}>
      <svg
        className="absolute inset-0 h-full w-full"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="hsl(var(--primary))" />
            <stop offset="50%" stopColor="hsl(var(--primary))" />
            <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity="0.5" />
          </linearGradient>
        </defs>
        <Icon className="h-full w-full" style={{ fill: "url(#gradient1)" }} />
      </svg>
    </div>
  );
};

export default GradientIcon;
